import script from "./otherFormSecond.vue?vue&type=script&setup=true&lang=js"
export * from "./otherFormSecond.vue?vue&type=script&setup=true&lang=js"

import "./otherFormSecond.vue?vue&type=style&index=0&id=1b01d3c9&lang=scss&scoped=true"

import exportComponent from "/var/www/ddup_czb/slczb_app_web/view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b01d3c9"]])

export default __exports__